import { render, staticRenderFns } from "./sushiStoreBannerMobile.vue?vue&type=template&id=bd3dce8c&scoped=true"
import script from "./sushiStoreBannerMobile.vue?vue&type=script&lang=js"
export * from "./sushiStoreBannerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3dce8c",
  null
  
)

export default component.exports